import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const customerApi = axios.create({
  baseURL: `${BACKEND_URL}/api`,
  // v2.6.9 batch BM-4 · `withCredentials: true` was removed. Cloudflare in
  // front of the API strips `Access-Control-Allow-Credentials` from CORS
  // preflight responses, which made every POST (e.g. /customer/quote) fail
  // with `ERR_NETWORK` for cross-origin riders on production. Google-authed
  // riders now also receive a Bearer JWT from /auth/google/session (set in
  // localStorage by AuthCallback) so cookie auth is no longer required for
  // the frontend to operate.
});

customerApi.interceptors.request.use((config) => {
  const token = localStorage.getItem("rtg_customer_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

customerApi.interceptors.response.use(
  (res) => res,
  (err) => {
    if (err?.response?.status === 401) {
      localStorage.removeItem("rtg_customer_token");
      localStorage.removeItem("rtg_customer");
      if (!window.location.pathname.startsWith("/ride/login") && window.location.pathname.startsWith("/ride")) {
        window.location.href = "/ride/login";
      }
    }
    return Promise.reject(err);
  }
);

export default customerApi;
